// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UsersAndGroupsQueryVariables = PrivateSchemaTypes.Exact<{
  search: PrivateSchemaTypes.Scalars['String'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.FilterDescriptor> | PrivateSchemaTypes.FilterDescriptor>;
}>;


export type UsersAndGroupsQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'UserModelPublic' }
    & Pick<PrivateSchemaTypes.UserModelPublic, 'id' | 'display_name' | 'userIdentity' | 'image_url'>
  )>, groups: Array<(
    { __typename?: 'GroupModelGQLBase' }
    & Pick<PrivateSchemaTypes.GroupModelGqlBase, 'id' | 'name'>
  )> }
);

export type InviteUserMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendEventInvite: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type InviteUserMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { inviteUser?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserEventModel' }
        & Pick<PrivateSchemaTypes.UserEventModel, 'created_at'>
      )> }
    )> }
  )> }
);

export type RecurringInviteUserMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendEventInvite: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type RecurringInviteUserMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { inviteUser?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventInviteeModel' }
        & Pick<PrivateSchemaTypes.RecurringEventInviteeModel, 'recurring_event_id' | 'created_at'>
      )> }
    )> }
  )> }
);

export type InviteGroupMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendEventInvite: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type InviteGroupMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { inviteGroup?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventGroupModel' }
        & Pick<PrivateSchemaTypes.EventGroupModel, 'created_at' | 'group_id' | 'event_id'>
      )> }
    )> }
  )> }
);

export type RecurringInviteGroupMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendEventInvite: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type RecurringInviteGroupMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { inviteGroup?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventInviteeGroupModel' }
        & Pick<PrivateSchemaTypes.RecurringEventInviteeGroupModel, 'created_at' | 'group_id'>
      )> }
    )> }
  )> }
);

export type AddAttendeesTo3dPartyCalendarsQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emails: Array<PrivateSchemaTypes.Scalars['String']> | PrivateSchemaTypes.Scalars['String'];
  groupIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddAttendeesTo3dPartyCalendarsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'addAttendeesTo3dPartyCalendars'>
    )> }
  )> }
);

export type AddAttendeesTo3dPartyCalendarsSeriesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emails: Array<PrivateSchemaTypes.Scalars['String']> | PrivateSchemaTypes.Scalars['String'];
  groupIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddAttendeesTo3dPartyCalendarsSeriesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'addAttendeesTo3dPartyCalendars'>
    )> }
  )> }
);


export const UsersAndGroupsDocument = gql`
    query usersAndGroups($search: String!, $filters: [FilterDescriptor!]) {
  users(search: $search, filters: $filters) {
    id
    display_name
    userIdentity
    image_url
  }
  groups(search: $search, filters: $filters) {
    id
    name
  }
}
    `;

/**
 * __useUsersAndGroupsQuery__
 *
 * To run a query within a React component, call `useUsersAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersAndGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUsersAndGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersAndGroupsQuery, UsersAndGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersAndGroupsQuery, UsersAndGroupsQueryVariables>(UsersAndGroupsDocument, options);
      }
export function useUsersAndGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersAndGroupsQuery, UsersAndGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersAndGroupsQuery, UsersAndGroupsQueryVariables>(UsersAndGroupsDocument, options);
        }
export type UsersAndGroupsQueryHookResult = ReturnType<typeof useUsersAndGroupsQuery>;
export type UsersAndGroupsLazyQueryHookResult = ReturnType<typeof useUsersAndGroupsLazyQuery>;
export type UsersAndGroupsQueryResult = Apollo.QueryResult<UsersAndGroupsQuery, UsersAndGroupsQueryVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($eventId: PositiveInt!, $userId: PositiveInt!, $sendEventInvite: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      inviteUser(
        userId: $userId
        sendInviteEmail: $sendEventInvite
        emailIdentityId: $emailIdentityId
      ) {
        created_at
      }
    }
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      sendEventInvite: // value for 'sendEventInvite'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const RecurringInviteUserDocument = gql`
    mutation recurringInviteUser($eventId: PositiveInt!, $userId: PositiveInt!, $sendEventInvite: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    recurringEvent(id: $eventId) {
      id
      inviteUser(
        userId: $userId
        sendInviteEmail: $sendEventInvite
        emailIdentityId: $emailIdentityId
      ) {
        recurring_event_id
        created_at
      }
    }
  }
}
    `;
export type RecurringInviteUserMutationFn = Apollo.MutationFunction<RecurringInviteUserMutation, RecurringInviteUserMutationVariables>;

/**
 * __useRecurringInviteUserMutation__
 *
 * To run a mutation, you first call `useRecurringInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringInviteUserMutation, { data, loading, error }] = useRecurringInviteUserMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      sendEventInvite: // value for 'sendEventInvite'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useRecurringInviteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecurringInviteUserMutation, RecurringInviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecurringInviteUserMutation, RecurringInviteUserMutationVariables>(RecurringInviteUserDocument, options);
      }
export type RecurringInviteUserMutationHookResult = ReturnType<typeof useRecurringInviteUserMutation>;
export type RecurringInviteUserMutationResult = Apollo.MutationResult<RecurringInviteUserMutation>;
export type RecurringInviteUserMutationOptions = Apollo.BaseMutationOptions<RecurringInviteUserMutation, RecurringInviteUserMutationVariables>;
export const InviteGroupDocument = gql`
    mutation inviteGroup($eventId: PositiveInt!, $groupId: PositiveInt!, $sendEventInvite: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      inviteGroup(
        groupId: $groupId
        sendInviteEmail: $sendEventInvite
        emailIdentityId: $emailIdentityId
      ) {
        created_at
        group_id
        event_id
      }
    }
  }
}
    `;
export type InviteGroupMutationFn = Apollo.MutationFunction<InviteGroupMutation, InviteGroupMutationVariables>;

/**
 * __useInviteGroupMutation__
 *
 * To run a mutation, you first call `useInviteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteGroupMutation, { data, loading, error }] = useInviteGroupMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      groupId: // value for 'groupId'
 *      sendEventInvite: // value for 'sendEventInvite'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useInviteGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteGroupMutation, InviteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteGroupMutation, InviteGroupMutationVariables>(InviteGroupDocument, options);
      }
export type InviteGroupMutationHookResult = ReturnType<typeof useInviteGroupMutation>;
export type InviteGroupMutationResult = Apollo.MutationResult<InviteGroupMutation>;
export type InviteGroupMutationOptions = Apollo.BaseMutationOptions<InviteGroupMutation, InviteGroupMutationVariables>;
export const RecurringInviteGroupDocument = gql`
    mutation recurringInviteGroup($eventId: PositiveInt!, $groupId: PositiveInt!, $sendEventInvite: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    recurringEvent(id: $eventId) {
      id
      inviteGroup(
        groupId: $groupId
        sendInviteEmail: $sendEventInvite
        emailIdentityId: $emailIdentityId
      ) {
        created_at
        group_id
      }
    }
  }
}
    `;
export type RecurringInviteGroupMutationFn = Apollo.MutationFunction<RecurringInviteGroupMutation, RecurringInviteGroupMutationVariables>;

/**
 * __useRecurringInviteGroupMutation__
 *
 * To run a mutation, you first call `useRecurringInviteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringInviteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringInviteGroupMutation, { data, loading, error }] = useRecurringInviteGroupMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      groupId: // value for 'groupId'
 *      sendEventInvite: // value for 'sendEventInvite'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useRecurringInviteGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecurringInviteGroupMutation, RecurringInviteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecurringInviteGroupMutation, RecurringInviteGroupMutationVariables>(RecurringInviteGroupDocument, options);
      }
export type RecurringInviteGroupMutationHookResult = ReturnType<typeof useRecurringInviteGroupMutation>;
export type RecurringInviteGroupMutationResult = Apollo.MutationResult<RecurringInviteGroupMutation>;
export type RecurringInviteGroupMutationOptions = Apollo.BaseMutationOptions<RecurringInviteGroupMutation, RecurringInviteGroupMutationVariables>;
export const AddAttendeesTo3dPartyCalendarsDocument = gql`
    query addAttendeesTo3dPartyCalendars($eventId: PositiveInt!, $emails: [String!]!, $groupIds: [PositiveInt!]!) {
  admin {
    event(id: $eventId) {
      addAttendeesTo3dPartyCalendars(emails: $emails, groupIds: $groupIds)
    }
  }
}
    `;

/**
 * __useAddAttendeesTo3dPartyCalendarsQuery__
 *
 * To run a query within a React component, call `useAddAttendeesTo3dPartyCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAttendeesTo3dPartyCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAttendeesTo3dPartyCalendarsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emails: // value for 'emails'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useAddAttendeesTo3dPartyCalendarsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddAttendeesTo3dPartyCalendarsQuery, AddAttendeesTo3dPartyCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddAttendeesTo3dPartyCalendarsQuery, AddAttendeesTo3dPartyCalendarsQueryVariables>(AddAttendeesTo3dPartyCalendarsDocument, options);
      }
export function useAddAttendeesTo3dPartyCalendarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddAttendeesTo3dPartyCalendarsQuery, AddAttendeesTo3dPartyCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddAttendeesTo3dPartyCalendarsQuery, AddAttendeesTo3dPartyCalendarsQueryVariables>(AddAttendeesTo3dPartyCalendarsDocument, options);
        }
export type AddAttendeesTo3dPartyCalendarsQueryHookResult = ReturnType<typeof useAddAttendeesTo3dPartyCalendarsQuery>;
export type AddAttendeesTo3dPartyCalendarsLazyQueryHookResult = ReturnType<typeof useAddAttendeesTo3dPartyCalendarsLazyQuery>;
export type AddAttendeesTo3dPartyCalendarsQueryResult = Apollo.QueryResult<AddAttendeesTo3dPartyCalendarsQuery, AddAttendeesTo3dPartyCalendarsQueryVariables>;
export const AddAttendeesTo3dPartyCalendarsSeriesDocument = gql`
    query addAttendeesTo3dPartyCalendarsSeries($eventId: PositiveInt!, $emails: [String!]!, $groupIds: [PositiveInt!]!) {
  admin {
    recurringEvent(id: $eventId) {
      addAttendeesTo3dPartyCalendars(emails: $emails, groupIds: $groupIds)
    }
  }
}
    `;

/**
 * __useAddAttendeesTo3dPartyCalendarsSeriesQuery__
 *
 * To run a query within a React component, call `useAddAttendeesTo3dPartyCalendarsSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAttendeesTo3dPartyCalendarsSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAttendeesTo3dPartyCalendarsSeriesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emails: // value for 'emails'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useAddAttendeesTo3dPartyCalendarsSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddAttendeesTo3dPartyCalendarsSeriesQuery, AddAttendeesTo3dPartyCalendarsSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddAttendeesTo3dPartyCalendarsSeriesQuery, AddAttendeesTo3dPartyCalendarsSeriesQueryVariables>(AddAttendeesTo3dPartyCalendarsSeriesDocument, options);
      }
export function useAddAttendeesTo3dPartyCalendarsSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddAttendeesTo3dPartyCalendarsSeriesQuery, AddAttendeesTo3dPartyCalendarsSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddAttendeesTo3dPartyCalendarsSeriesQuery, AddAttendeesTo3dPartyCalendarsSeriesQueryVariables>(AddAttendeesTo3dPartyCalendarsSeriesDocument, options);
        }
export type AddAttendeesTo3dPartyCalendarsSeriesQueryHookResult = ReturnType<typeof useAddAttendeesTo3dPartyCalendarsSeriesQuery>;
export type AddAttendeesTo3dPartyCalendarsSeriesLazyQueryHookResult = ReturnType<typeof useAddAttendeesTo3dPartyCalendarsSeriesLazyQuery>;
export type AddAttendeesTo3dPartyCalendarsSeriesQueryResult = Apollo.QueryResult<AddAttendeesTo3dPartyCalendarsSeriesQuery, AddAttendeesTo3dPartyCalendarsSeriesQueryVariables>;